// Organization API Service - Backend Integration
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';
import MockDataService from '../services/MockDataService';

const USE_MOCK = process.env.REACT_APP_USE_MOCK_DATA === 'true' || process.env.NODE_ENV === 'development';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

export const getOrganizations = async (params = {}) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getOrganizations(params);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet('/api/auth/organization/organizations', params);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet('/api/auth/organization/organizations', params);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getOrganizations(params);
    return wrapResponse(response.data);
  }
};

export const createOrganization = async (data) => {
  const response = await apiPost('/api/auth/organization/organizations', data);
  return wrapResponse(response);
};

export const getOrganizationById = async (orgId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getOrganizationById(orgId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/api/auth/organization/organizations/${orgId}`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/api/auth/organization/organizations/${orgId}`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getOrganizationById(orgId);
    return wrapResponse(response.data);
  }
};

export const updateOrganization = async (orgId, data) => {
  const response = await apiPut(`/api/auth/organization/organizations/${orgId}`, data);
  return wrapResponse(response);
};

export const deleteOrganization = async (orgId) => {
  const response = await apiDelete(`/api/auth/organization/organizations/${orgId}`);
  return wrapResponse(response);
};

export const getOrganizationDepartments = async (orgId) => {
  const response = await apiGet(`/api/auth/organization/organizations/${orgId}/departments`);
  return wrapResponse(response);
};

export const getOrganizationUsers = async (orgId) => {
  const response = await apiGet(`/api/auth/organization/organizations/${orgId}/users`);
  return wrapResponse(response);
};

export const getOrganizationsByTenant = async (tenantId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getOrganizationsByTenant(tenantId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/api/auth/organization/tenants/${tenantId}/organizations`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/api/auth/organization/tenants/${tenantId}/organizations`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getOrganizationsByTenant(tenantId);
    return wrapResponse(response.data);
  }
};

// Service object for backward compatibility
export const organizationService = {
  getOrganizations,
  createOrganization,
  getOrganizationById,
  updateOrganization,
  deleteOrganization,
  getOrganizationDepartments,
  getOrganizationUsers,
  getOrganizationsByTenant,
};

export default organizationService;
